<div class="row">
    <div [class.d-none]="countDown>0" class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!isDone">
            <div class="d-flex justify-content-center mb-3">
                <div class="quiz-counter">
                    {{numberOfQuiz}} of {{totalQuiz}}
                </div>
            </div>
            <div class="progress mb-3">
                <div class="progress-bar" role="progressbar" [style.width]="percentQuiz+'%'"></div>
            </div>
            <div *ngIf="currentAnswer.length" class="card bg-light rounded-5 text-dark mb-3 position-relative">
                <div style="margin-top:-1px;" class="px-4 w-100 position-absolute start-0">
                    <div class="bg-success progress-timeout rounded" style="height:3px;" [style.width]="percentTimeOut+'%'">&nbsp;</div>
                </div>
                <div class="card-body text-center">
                    <div class="question d-flex justify-content-center align-items-center">
                        <img style="max-height:100px;width:auto;max-width:100%;" src="{{assetUrl}}{{currentQuestion.image}}">
                    </div>
                </div>
            </div>
            <div *ngIf="currentAnswer.length" class="row d-flex justify-content-center align-items-center">
                <div *ngFor="let item of currentAnswer;index as i" class="col-3 answer d-flex justify-content-center">
                    <button (click)="answerQuiz(item);" class="btn rounded-4 btn-item mb-3 w-100 h-100">
                        <img style="max-height:64px;width:auto;max-width:100%;" src="{{assetUrl+item.image}}">
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="isDone" class="px-md-5">
            <app-finish [image]="graphImage" [point]="point" [time]="(elapsedTime/1000)" [title]="'Processing Speed'"></app-finish>
        </div>
    </div>
    <div *ngIf="countDown>0 && !loading.status" class="col-12 text-center p-5">
        <h4>Ready?</h4>
        <h3>{{countDown}}</h3>
    </div>
</div>
